export default "__VITE_ASSET__CShbNxjy__"